import { LayoutItem, ResponsiveGridLayoutProps } from "react-grid-layout";
import { DashboardComponentKind } from '../../types/dashboards/dashboardComponent.type';

export const DASHBOARD_GRID_CONFIG: Partial<ResponsiveGridLayoutProps> = {
  cols: {
    lg: 12,
    sm: 1,
  },
  breakpoints: {
    lg: 720,
    sm: 0,
  },
  rowHeight: 60,
  containerPadding: [8, 0],
  margin: [16, 16],
};

export const DASHBOARD_LAYOUT_ITEM_CONFIG: Partial<LayoutItem> = {
  minH: 3,
  minW: 3,
  resizeHandles: ['e', 'n', 'ne', 'nw', 's', 'se', 'sw', 'w'],
}

export const DASHBOARD_LAYOUT_ITEM_CONFIG_BY_KIND: Partial<Record<DashboardComponentKind, Partial<LayoutItem>>> = {
  [DashboardComponentKind.Value]: {
    minH: 2,
  },
  [DashboardComponentKind.Table]: {
    minW: 4,
    minH: 4,
  },
}

export const DASHBOARD_COMPONENT_DEFAULT_WIDTH = 6;
export const DASHBOARD_COMPONENT_DEFAULT_HEIGHT = 4;
